export const iconFontAwesomeAccessibilityEye = (
	<i className="fa-solid fa-eye"></i>
);
